<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      班级管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
            v-model="keyword"
            placeholder="请输入班级名称"
            class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>

        <div>
          <router-link to="/fuse/studentExamine">
            <el-button type="primary">
              <p class="flex align-center font-size">
                <i class="el-icon-finished margin-right-xs"></i>学生审核
              </p>
            </el-button>
          </router-link>
          <el-button
            type="primary"
            @click="dialog = true"
            class="margin-left-sm"
          >
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>新增班级
            </p>
          </el-button>
        </div>
      </div>
      <div class="table-warpper">
        <el-table
          :data="classtList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="入学年份" width="100">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.year }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="班级名称" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.class_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="班级人数" width="150">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_num }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="班级教务" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.per_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="班级学制" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.class_type === 1 ? "3年制大专" : "4年制本科" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="入学时间" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.open_date }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="毕业时间" width="120">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.graduate_date }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="500">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                  size="medium"
                  type="primary"
                  @click="editItem(scope.row)"
                  >编辑
                </el-button>
                <el-button
                  size="medium"
                  type="primary"
                  @click="showImg(scope.row)"
                  >二维码
                </el-button>
                <router-link
                  :to="'/fuse/student?id=' + scope.row.class_id"
                  class="margin-lr-xs"
                >
                  <el-button size="medium" type="primary">学生管理 </el-button>
                </router-link>
                <router-link
                  :to="'/fuse/course?id=' + scope.row.class_id"
                  class="margin-right-xs"
                >
                  <el-button size="medium" type="primary">课程管理 </el-button>
                </router-link>
                <el-button
                  size="medium"
                  type="danger"
                  @click="deleteItem(scope.row.class_id)"
                  >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="classtList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <class-dialog
      :setId="setId"
      :setItem="setItem"
      :dialog="dialog"
      @cancelDialog="cancelDialog"
    />

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :title="className"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <div>
        <img
          :src="classImg"
          alt=""
          width="300"
          style="display: block; margin: 0 auto 30px"
        />
        <div class="flex align-center justify-around">
          <el-link :href="classImg" target="_blank" download :underline="false">
            <el-button type="primary" style="width: 200px">下载</el-button>
          </el-link>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { classList, classDel,classCodeImg } from "@/api/fuse";
import {IMGURL} from '@/config/index'
import classDialog from "@/views/fuse/page/dialog/classDialog";


export default {
  name: "class",
  components: { classDialog },
  data () {
    return {
      keyword: "",
      status: "",
      classtList: [],
      page: 1,
      total: 0,
      limit: 10,
      dialog: false,
      setId: 0,
      setItem: {},
      className: '',
      classImg: '',
      centerDialogVisible: false,
    };
  },
  computed:{
    imgurl(){
      return IMGURL
    }
  },
  created () {
    this.$emit(
      "setIndex",
      this.$route.path,
      "当前位置：班级管理",
      false
    );
    if (this.$route.query.page) this.page = Number(this.$route.query.page)
    this.getList()
  },
  methods: {
    async getList () {
      let _list = await classList(this.keyword, this.page, this.limit)
      this.classtList = _list.data.list
      this.total = _list.data.count
    },
    handleClose () {
      this.className = ''
      this.classImg = ''
      this.centerDialogVisible = false
    },

    async showImg (obj) {
      let _data = await classCodeImg(obj.class_id)
      console.log(_data)
      this.className = obj.class_name
      this.classImg = this.imgurl + _data.data.img
      this.centerDialogVisible = true
    },


    editItem (obj) {
      this.setId = obj.class_id
      this.setItem = obj
      this.dialog = true
    },
    cancelDialog (val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.dialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.dialog = false;
      }
    },
    deleteItem (id) {
      this.$confirm("确定要删除该班级吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete (id) {
      let _state = await classDel(id);
      if (this.classtList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    //  修改路径
    setPath () {
      this.$router.push({
        path: '/fuse/class',
        query: {
          page: this.page,
          keyword: this.keyword,
        }
      })
    },
    onSearch () {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
  },
  watch: {
    page () {
      this.setPath()
    },
    $route () {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
</style>